import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.page.title')), 1),
        _createVNode(_component_ReglePastille, { cle: "contact.definition" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent)))
      ])
    ]),
    _createVNode(_component_BottomNavigation, {
      back: _ctx.back,
      cancel: _ctx.cancel,
      confirm: _ctx.request,
      confirmButtonDisabled: !_ctx.isValid,
      first: _ctx.step === 0,
      last: _ctx.isLastStep,
      next: _ctx.next
    }, null, 8, ["back", "cancel", "confirm", "confirmButtonDisabled", "first", "last", "next"]),
    (_ctx.isSending)
      ? (_openBlock(), _createBlock(_component_WaitingModal, {
          key: 0,
          text: _ctx.$t('contact.page.message.sending')
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.isSuccess)
      ? (_openBlock(), _createBlock(_component_SuccessModal, {
          key: 1,
          subtitle: _ctx.$t('contact.page.message.sent'),
          title: '',
          onClick: _ctx.cancel
        }, null, 8, ["subtitle", "onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}